/**
 * Cờ tính năng hệ thống – Bật/tắt Trợ lý Thu mua AI, v.v.
 * Migrated to Supabase via Settings domain.
 */

import { settingsDomain } from '@domain/settings/SettingsDomainFactory';

/**
 * @param {string} uid
 * @returns {Promise<{ sourcingAiEnabled: boolean }>}
 */
export async function getFeatureFlags(uid) {
  if (!uid) return { sourcingAiEnabled: false };
  const repo = settingsDomain.getSettingsRepository();
  return await repo.getFeatureFlags(uid);
}

/**
 * @param {string} uid
 * @param {boolean} value
 */
export async function setSourcingAiEnabled(uid, value) {
  if (!uid) throw new Error('uid là bắt buộc');
  const repo = settingsDomain.getSettingsRepository();
  await repo.saveFeatureFlag(uid, 'sourcingAiEnabled', !!value);
}

/**
 * Subscribe to feature flags (real-time).
 * @param {string} uid
 * @param {(flags: object) => void} callback
 * @returns {() => void} Unsubscribe
 */
export function listenFeatureFlags(uid, callback) {
  if (!uid) {
    callback({ sourcingAiEnabled: false });
    return () => {};
  }
  const repo = settingsDomain.getSettingsRepository();
  return repo.listenFeatureFlags(uid, callback);
}

/**
 * Generic setter for any feature flag
 * @param {string} uid
 * @param {string} flagKey
 * @param {boolean} value
 */
export async function setFeatureFlag(uid, flagKey, value) {
  if (!uid || !flagKey) throw new Error('uid và flagKey là bắt buộc');
  const repo = settingsDomain.getSettingsRepository();
  await repo.saveFeatureFlag(uid, flagKey, !!value);
}
